"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _odometerSsrSafe = _interopRequireDefault(require("./odometer-ssr-safe"));
var _reactIntersectionObserver = require("react-intersection-observer");
require("./odometer-theme-minimal.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const Counter = _ref => {
  let {
    value
  } = _ref;
  const [ref, inView] = (0, _reactIntersectionObserver.useInView)({
    threshold: 0,
    triggerOnce: true
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_odometerSsrSafe.default, {
    value: inView ? value : 0,
    format: "(.ddd)",
    duration: 5000,
    theme: "minimal"
  }));
};
var _default = Counter;
exports.default = _default;